<script>
import Layout from '@/router/layouts/main';
import { api } from '@/state/services';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import Password from '@/components/widgets/input-password';

export default {
  locales: {
    pt: {
      'Security PIN': 'PIN de Segurança',
      'Recover security PIN': 'Recuperar PIN de segurança',
      'Yes': 'Sim',
      'Close': 'Fechar',

      'Current password access': 'Senha atual de acesso',
      'Current Security PIN': 'Senha de segurança atual',
      'New security PIN': 'Novo PIN de segurança',
      'New security PIN is required.': 'Novo PIN de segurança é obrigatória.',
      'New security PIN must be greater than 6 characters.': 'O novo PIN de segurança deve ter mais de 6 caracteres.',
      'Confirm security PIN': 'Confirmar novo PIN de segurança',
      'Confirm security PIN is required.': 'Confirmar PIN de segurança é obrigatório.',
      'Confirm security PIN must be greater than 6 characters.': 'O novo PIN de segurança deve ter mais de 6 caracteres.',
      'New security PIN and confirm security PIN must be identical.': 'O novo PIN e confirmar PIN tem que ser iguais.',
      'Save': 'Salvar',

      'The current password entered is invalid.': 'A senha atual de acesso informada é inválida.',
      'The current security PIN entered is invalid.': 'O PIN atual de segurança informada é inválida.',
      'Your security PIN has been changed successfully.': 'Seu PIN de segurança foi alterada com sucesso.',

      'A code for creating a new password will be sent to your email. You have up to 24 hours to change your password. Do you want to recover your security PIN?': 'Um código para criação de uma novo PIN será enviado ao seu e-mail. Você tem até 24 horas para alterar sua senha. Deseja recuperar seu PIN de segurança?',
      'We have sent an email to retrieve your security PIN.': 'Enviamos um email para recuperar seu PIN de segurança.',
      'There was an error sending the recovery email, please try again later.': 'Ocorreu um erro ao enviar o e-mail de recuperação. Tente novamente mais tarde.',
    },
    es: {
      'Security PIN': 'PIN de Seguridad',
      'Recover security PIN': 'Recuperar PIN de seguridad',
      'Yes': 'Si',
      'Close': 'Cerrar',

      'Current password access': 'Contraseña actual de accesso',
      'Current password access must be greater than 6 characters.': 'La contraseña de acesso debe tener más de 6 caracteres.',
      'Current Security PIN': 'PIN de seguridad actual',
      'New security PIN': 'Nuevo PIN de seguridad',
      'New security PIN is required.': 'Se requiere nuevo PIN de seguridad',
      'New security PIN must be greater than 6 characters.': 'La nuevo PIN de seguridad debe tener más de 6 caracteres.',
      'Confirm security PIN': 'Confirmar PIN de seguridad',
      'Confirm security PIN is required.': 'Se requiere confirmar el PIN de seguridad.',
      'Confirm security PIN must be greater than 6 characters.': 'El nuevo PIN de seguridad debe tener más de 6 caracteres.',
      'New security PIN and confirm security PIN must be identical.': 'El nuevo PIN y confirmar PIN deben ser idénticas.',
      'Save': 'Salvar',

      'The current password entered is invalid.': 'La contraseña actual ingresada no es válida.',
      'The current security PIN entered is invalid.': 'El PIN de seguridad actual ingresada no es válida.',
      'Your security PIN has been changed successfully.': 'Su PIN de seguridad se ha cambiado correctamente.',

      'A code for creating a new password will be sent to your email. You have up to 24 hours to change your password. Do you want to recover your security PIN?': 'Use le enviará un código para crear una nueva contraseña a su correo electrónico. Tienes hasta 24 horas para cambiar tu contraseña. ¿Quieres recuperar tu PIN de seguridad?',
      'We have sent an email to retrieve your security PIN.': 'Hemos enviado un correo electrónico para recuperar su PIN de seguridad.',
      'There was an error sending the recovery email, please try again later.': 'Se produjo un error al enviar el correo electrónico de recuperación. Vuelve a intentarlo más tarde.',
    }
  },
  components: { Layout, Password },
  data() {
    return {
      token: null,

      alert: {
        password: { type: '', message: '' },
        recover: { type: '', message: '' },
        reset: { type: '', message: '' },
      },

      passwordSecurity: {
        status: true,
      },

      password: {
        currentPassword: "",
        currentSecurity: "",
        newSecurity: "",
        confirmSecurity: ""
      },
    };
  },
  validations: {
    password: {
      currentPassword: { required, minLength: minLength(6) },
      currentSecurity: { minLength: minLength(6) },
      newSecurity: { required, minLength: minLength(6) },
      confirmSecurity: { required, minLength: minLength(6), sameAs: sameAs('newSecurity') },
    }
  },
  methods: {
    getPasswordSecurity() {
      api
        .get('password/security')
        .then(response => {
          if (response.data.status==='registered') {
            this.passwordSecurity.status = true
          } else {
            this.passwordSecurity.status = false
          }
        });
    },
    passwordSubmit() {
      this.$v.password.$touch();
      if (this.$v.password.$invalid) {
        return;
      } else {
        const { currentPassword, newSecurity, confirmSecurity } = this.password;
        if (currentPassword && newSecurity && confirmSecurity ) {
          api
            .post('password/security', {
              currentPassword: this.password.currentPassword,
              currentSecurity: this.password.currentSecurity,
              newSecurity: this.password.newSecurity,
              confirmSecurity: this.password.confirmSecurity
            })
            .then(response => {
              if (response.data.status=='success') {
                this.password.currentPassword = ''
                this.password.currentSecurity = ''
                this.password.newSecurity = ''
                this.password.confirmSecurity = ''

                this.$v.password.$reset();

                this.passwordSecurity.status = true

                this.alert.password.type    = 'alert-success'
                this.alert.password.message = response.data.message
              } else {
                this.alert.password.type    = 'alert-danger'
                this.alert.password.message = response.data.message
              }
            });
        }
      }
    },
    recoverSecurity() {
      api
        .post('password/security/recover')
        .then(response => {
          if (response.data.status=='success') {
            this.alert.recover.type    = 'success';
            this.alert.recover.message = response.data.message;
          }
        });
    },
    resetSecurity() {
      api
        .get('password/security/recover/' + this.$route.query.token)
        .then(response => {
          if (response.data.status=='success') {
            this.$router.push('/account/password/security');

            this.alert.reset.type    = 'success';
            this.alert.reset.message = response.data.message;
          } else {
            this.alert.reset.type    = 'danger';
            this.alert.reset.message = response.data.message;
          }
        })
    }
  },
  mounted() {
    this.getPasswordSecurity();
    if (this.$route.query.token) {
      this.resetSecurity();
    }
  }
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex justify-content-between">
          <h4 class="mb-0 font-size-18">{{ t('Security PIN') }}</h4>
          <b-button v-if="this.passwordSecurity.status" variant="primary" @click="$bvModal.show('recoverSecurity')">{{ t('Recover security PIN') }}</b-button>
          <b-modal id="recoverSecurity" hide-footer>
            <template v-slot:modal-title>
              {{ t('Recover security PIN') }}
            </template>
            <b-form class="p-3" @submit.prevent="recoverSecurity">
              <div class="d-block text-center">
                <p>{{ t('A code for creating a new password will be sent to your email. You have up to 24 hours to change your password. Do you want to recover your security PIN?') }}</p>
              </div>
              <div class="d-flex flex-row">
                <b-button class="m-3" variant="primary" type="submit" block @click="$bvModal.hide('recoverSecurity')">{{ t('Yes') }}</b-button>
                <b-button class="m-3" variant="default" block @click="$bvModal.hide('recoverSecurity')">{{ t('Close') }}</b-button>
              </div>
            </b-form>
          </b-modal>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div v-if="alert.reset.message" :class="'card bg-' + alert.reset.type + ' text-white'">
          <div class="card-body">
            {{ t(alert.reset.message) }}
          </div>
        </div>
        <div v-else-if="alert.recover.message" :class="'card bg-' + alert.recover.type + ' text-white'">
          <div class="card-body">
            {{ t(alert.recover.message) }}
          </div>
        </div>
        <div v-else-if="!this.passwordSecurity.status" class="card bg-default text-white">
          <div class="card-body">
            Você ainda não possui uma senha de segurança cadastrada, para cadastrar preencha o formulário abaixo.
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <b-form class="p-3" @submit.prevent="passwordSubmit">
              <div v-if="alert.password.message" :class="'alert ' + alert.password.type">{{ t(alert.password.message) }}</div>
              <b-form-group id="current-bo" :label="t('Current password access')" label-for="current-bo">
                <Password v-model="password.currentPassword" :v="$v.password.currentPassword"></Password>
              </b-form-group>
              <b-form-group v-if="this.passwordSecurity.status" id="current-security" :label="t('Current Security Password')" label-for="current-security">
                <Password v-model="password.currentSecurity" :v="$v.password.currentSecurity"></Password>
              </b-form-group>
              <b-form-group id="newest-security" :label="t('New security password')" label-for="newest-security">
                <Password v-model="password.newSecurity" :v="$v.password.newSecurity"></Password>
              </b-form-group>
              <b-form-group id="confirm-security" :label="t('Confirm security password')" label-for="confirm-security">
                <Password v-model="password.confirmSecurity" :v="$v.password.confirmSecurity"></Password>
              </b-form-group>
              <div class="mt-4">
                <b-button :disabled="!this.password.currentPassword || !this.password.newSecurity || !this.password.confirmSecurity" type="submit" variant="default">{{ t('Save') }}</b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>